import React from "react";
import { connect } from "react-redux";

import { isInformationModalOpen, getInformationModalMessage, getInformationModalTitle } from "state/app/selectors";
import { closeInformationModal } from "state/app/actions";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";

import "./InformationModal.css";

class InformationModal extends React.Component {

  onClose = () => {
    this.props.closeInformationModal();
  }

  render() {
    const { isOpen, title, message} = this.props;
    if(!isOpen) {return null;}

    return (
      <ModalDialog isOpen={isOpen}>
        <div>
          <div className="information-modal__title">{title}</div>
          <div className="information-modal__message">{message}</div>
          <div className="information-modal__button-container">
            <Button className="information-modal__ok-button" onClick={this.onClose}>OK</Button>
          </div>
        </div>
      </ModalDialog>
    );
  }

}

export default connect(
  state => ({
    isOpen: isInformationModalOpen(state),
    message: getInformationModalMessage(state),
    title: getInformationModalTitle(state)
  }),
  { closeInformationModal }
)(InformationModal);



// WEBPACK FOOTER //
// ./src/components/app/InformationModal.js